import styled from 'styled-components';
import { Label } from 'common/baseComponents'
import { SIZE, LAYERS } from 'common/sizes';

import { LABEL, LIST } from 'common/base';

export const MainContainer = styled.div`
    margin: 0px 0px 0px 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const IconsContainer = styled.div`
    display: flex;
    grid-gap: 12px;
    padding-left: 28px;
    padding-bottom: 0px;
`;

export const IconContainer = styled.div`
    cursor: pointer;
`;